import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import { getIdWithPrefix } from 'utils/pathUtils'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import ConvenienceDoorsTableSection from 'components/Cards/ConvenienceDoorsSection'

export default function ConveniencePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const convenienceID = urlParams?.convenience_id
    ? getIdWithPrefix(
        urlParams?.convenience_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Convenience]
      )
    : undefined

  const api = apiService()
  const { data, isLoading, isError, error } =
    api.useGetConvenience(convenienceID)

  return (
    <CommonPage
      uniqueCompanyTypeId={convenienceID}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="convenience"
      companyTypeSlug="convenience"
      breadcrumbs={[
        {
          title: 'Convenience Stores',
          breadcrumb: data?.cstore?.name,
        },
      ]}
      getFieldsFromData={(data) => ({
        contactCompanyId: data?.id,
        companyName: data?.cstore?.name,
        websiteAddress: data?.cstore?.domain,
      })}
      customSectionItems={
        data ? (
          <ConvenienceDoorsTableSection forChainProxyId={data!.id} />
        ) : null
      }
    />
  )
}
